import React from "react";
import Marquee from "react-fast-marquee";

/**
 * Slow editorial marquee separating sections.
 * Massive outline serif text — brand statement crawling across the width.
 */
const EditorialMarquee = ({
    text = "Victory · Foods & Beverages · Bottled with Purpose ·",
    speed = 18,
    theme = "light",
}) => {
    const color = theme === "light" ? "text-crimson-800" : "text-ivory-100";
    return (
        <div
            className={`section-ivory cv-auto relative z-10 border-y py-8 ${theme === "dark" ? "section-ink border-ivory-100/10" : "border-crimson-800/15"}`}
            data-testid="editorial-marquee"
        >
            <Marquee
                gradient={false}
                speed={speed}
                pauseOnHover={false}
                className="overflow-hidden"
            >
                <span
                    className={`stroke-serif ${color} mx-8 text-[14vw] italic leading-none tracking-tightest md:text-[10vw]`}
                >
                    {text} {text} {text}
                </span>
            </Marquee>
            {/* Gold hairline top */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-x-0 top-0 h-px"
            >
                <div className="divider-gold h-full w-full" />
            </div>
        </div>
    );
};

export default EditorialMarquee;
